var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28 10.5c-11.67 0-21.63 7.257-25.67 17.5 4.037 10.24 14 17.5 25.67 17.5s21.63-7.257 25.67-17.5c-4.037-10.24-14-17.5-25.67-17.5zm0 29.17c-6.44 0-11.67-5.227-11.67-11.67s5.227-11.67 11.67-11.67 11.67 5.227 11.67 11.67-5.227 11.67-11.67 11.67zm0-18.67c-3.873 0-7 3.127-7 7s3.127 7 7 7 7-3.127 7-7-3.127-7-7-7z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default "data:image/svg+xml,%3csvg version='1.1' viewBox='0 0 56 56' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='m28 10.5c-11.67 0-21.63 7.257-25.67 17.5 4.037 10.24 14 17.5 25.67 17.5s21.63-7.257 25.67-17.5c-4.037-10.24-14-17.5-25.67-17.5zm0 29.17c-6.44 0-11.67-5.227-11.67-11.67s5.227-11.67 11.67-11.67 11.67 5.227 11.67 11.67-5.227 11.67-11.67 11.67zm0-18.67c-3.873 0-7 3.127-7 7s3.127 7 7 7 7-3.127 7-7-3.127-7-7-7z' fill-rule='evenodd'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };